
<template>
  <div class="main">
    <Slider :sliderArr='sliderArr'/>
    <div class="content">
      <div class="service"><div>
        <div class="stitle"><span><em>——</em>&nbsp;&nbsp;王牌服务&nbsp;&nbsp;<em>——</em></span></div>
        <ul class="serv_cate"><li><div><a href="/service?page=0"><img style="width:80px" src="../assets/images/index-service1.png" alt="SCI论文英文润色">
        <span>SCI论文英文润色</span>
        <i class="el-icon-right icon"></i>
        </a>
        <p>根据客户的研究领域和要求，提供一对一的个性化专业服务，为您的论文的投稿和发表保驾护航。</p>
        <dl><dd><em class="circle"></em><span>100%英语母语编辑</span></dd>
        <dd><em class="circle"></em><span>1000+细分领域精确匹配</span></dd>
        <dd><em class="circle"></em><span>免费多轮售后保障服务</span></dd></dl>
        </div></li>
        <li><div><a href="/service?page=1"><img style="width:80px" src="../assets/images/index-service2.png" alt="专业学术翻译">
        <span>专业学术翻译</span>
        <i class="el-icon-right icon"></i>
        </a>
        <p>专业学术翻译团队由不同专业领域的华人科学家与母语为英语的专家组成。所有专家的资历均为国际排名前100的院校博士毕业，具有很深的学术造诣和丰富的论文编辑经验。</p>
        <dl><dd><em class="circle"></em><span>专业领域资深专家</span></dd>
        <dd><em class="circle"></em><span>1000+细分领域精确匹配</span></dd>
        <dd><em class="circle"></em><span>资深专家丰富行业经验保驾护航</span></dd></dl>
        </div></li>
        <li><div><a href="/service?page=3"><img style="width:80px" src="../assets/images/index-service3.png" alt="SCI发表学术支持">
        <span>SCI发表学术支持</span>
        <i class="el-icon-right icon"></i>
        </a>
        <p>来自全球顶尖高等学府的教授、审稿人和期刊编辑团队，提供从学术内容提升、预先审稿、投稿期刊选择、排版、投稿协助等全方位支持，有效提高论文的接收成功率。</p>
        <dl><dd><em class="circle"></em><span>投稿期刊推荐、审稿人意见回复</span></dd>
        <dd><em class="circle"></em><span>论文图表及摘要、数据统计分析</span></dd>
        <dd><em class="circle"></em><span>论文Cover Letter写作、期刊格式排版</span></dd></dl>
        </div></li>
        <li><div><a href="/other?page=0"><img  style="width:80px" src="../assets/images/index-service4.png" alt="基金标书服务">
        <span>基金标书服务</span>
        <i class="el-icon-right icon"></i>
        </a>
        <p>资深基金标书专家，从立项依据、研究内容、创新性及可行性对标书内容进行提升，帮助作者更加规范、科学、专业的撰写和完善项目申请标书，提高中标几率！</p>
        <dl><dd><em class="circle"></em><span>标书修改、指导、评估、润色</span></dd>
        <dd><em class="circle"></em><span>经验丰富的服务团队护航</span></dd>
        <dd><em class="circle"></em><span>免费多轮修改和二次评估</span></dd></dl>
        </div></li>
        </ul></div></div>
      <div class="tech"><div>
        <div class="stitle"><span><em>——</em>&nbsp;&nbsp;技术服务&nbsp;&nbsp;<em>——</em></span></div>
        <ul class="serv_cate"><li><div><a href="/tech?page=0"><img style="width:76px" src="../assets/images/index-tech1.png" alt="形态病理学">
        <span>形态病理学</span>
        <i class="el-icon-right icon"></i>
        </a>
        <dl><dd><a href="tech/detail?index=0&subIndex=1">石蜡包埋</a></dd>
        <dd><a href="tech/detail?index=0&subIndex=3">免疫组化</a></dd>
        <dd><a href="tech/detail?index=0&subIndex=4">免疫荧光</a></dd>
        <dd><a href="tech/detail?index=0&subIndex=2">特殊染色</a></dd></dl>
        </div></li>
        <li><div><a href="/tech?page=5"><img src="../assets/images/index-tech2.png" style="width:76px" alt="拍片及分析">
        <span>拍片及分析</span><i class="el-icon-right icon"></i></a>
        <dl><dd><a href="">免疫组化分析</a></dd>
        <dd><a href="">免疫荧光</a></dd>
        <dd><a href="">特殊染色分析</a></dd>
        <dd><a href="">激光共聚焦</a></dd></dl>
        </div></li>
        <li><div><a href="/tech?page=2"><img src="../assets/images/index-tech3.png" style="width:76px" alt="细胞学">
        <span>细胞学</span><i class="el-icon-right icon"></i></a>
        <dl><dd><a href="tech/detail?index=2&subIndex=2">原代细胞培养</a></dd>
        <dd><a href="tech/detail?index=2&subIndex=1">细胞划痕实验</a></dd>
        <dd><a href="tech/detail?index=2&subIndex=3">细胞增殖与活性检测</a></dd></dl>
        </div></li>
        <li><div><a href="/tech?page=1"><img src="../assets/images/index-tech4.png" style="width:76px" alt="分子生物学">
        <span>分子生物学</span><i class="el-icon-right icon"></i></a>
        <dl><dd><a href="tech/detail?index=1&subIndex=2">Western Blot</a></dd>
        <dd><a href="tech/detail?index=1&subIndex=1">实时荧光</a></dd>
        <dd><a href="tech/detail?index=1&subIndex=3">染色质免疫共沉淀</a></dd>
        <dd><a href="tech/detail?index=1&subIndex=4">免疫共沉淀</a></dd></dl>
        </div></li>
         <li><div><a href="/tech?page=3"><img src="../assets/images/index-tech5.png" style="width:76px" alt="斑马鱼实验">
        <span>斑马鱼实验</span><i class="el-icon-right icon"></i></a>
        <dl><dd><a href="tech/detail?index=4&subIndex=1">基因编辑技术</a></dd>
        <dd><a href="tech/detail?index=4&subIndex=2">毒性实验</a></dd>
        <dd><a href="tech/detail?index=4&subIndex=3">行为学检测</a></dd></dl>
        </div></li>
         <li><div><a href="/tech?page=4"><img src="../assets/images/index-tech6.png" style="width:76px" alt="病毒包装">
        <span>病毒包装</span><i class="el-icon-right icon"></i></a>
        <dl>
        <dd><a href="tech/detail?index=4&subIndex=1">慢病毒</a></dd>
        <dd><a href="/tech?page=4">慢病毒介导细胞</a></dd>
        <dd><a href="tech/detail?index=4&subIndex=2">ELISA</a></dd></dl>
        </div></li>
        </ul></div></div>
      <div class="services panel-box" >
        <div class="container" >
          <div class="panel-title" >
            <h3 >专业用心，打造极致客户体验</h3>
            <p class="hide-h5">感谢您的选择与信赖，您的每一句建议与认可，都在鞭策我们向着更好的方向走下去！</p>
          </div> 
          <div class="services-layout flex" >
            <div class="item flex-s flex flex-column" >
              <div class="label flex-s flex flex-middle" >
                <div class="icon" ><img src="../assets/images/index-info1.png" alt="全天候极速响应"/></div> 
                <div class="info" ><h5 >全天候<span >极速响应</span></h5> <p >7×24小时在线服务，第一时间响应客户咨询</p></div>
              </div> 
              <div class="label flex-s flex flex-middle" >
                <div class="icon" ><img src="../assets/images/index-info2.png" alt="一对一专业服务"/></div> 
                <div class="info" ><h5 >一对一<span >专业服务</span></h5> <p >由专属客户经理提供全方位贴心服务</p></div>
              </div>
              <div class="label flex-s flex flex-middle" >
                <div class="icon" ><img src="../assets/images/index-info3.png" alt="极致的安全保障"/></div> 
                <div class="info" ><h5 >极致的<span >安全保障</span></h5> <p >对客户的相关行为作出承诺确保客户隐私安全</p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from '@/components/Slider'
import List from '@/components/List'
export default {
  name: 'index',
  components: {
    Slider,
    List
  },
  data () {
    return {
      sliderArr: [
        require('@/assets/images/index-banner.png'),
        require('@/assets/images/sci-banner.png'),
        require('@/assets/images/tech-banner.png'),
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.content{
  width: 1440px;
  margin: 0px auto;
  .services{
    background:#fff;
    .panel-box{
      padding: 80px 0;
    }
    .container{
      width: 1440px;
      margin-left: auto;
      margin-right: auto;
      .panel-title {
        position: relative;
        z-index: 5;
        line-height: 1.47;
        margin-bottom: 40px;
        text-align: center;
        h3{
          font-size:32px;
        }
        p {
            font-size: 18px;
            margin-top: -20px;
        }
      }
      .item{
        .label{
          background: #4978a6;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 3px 16px #22000000;
          padding: 25px 30px;
          color: #fff;
          margin:0 10px 50px;
          img{
            width: 120px;
            height: 83px;
          }
          .info{
            margin-left:40px;

            h5{
              font-size: 18px;
              line-height: 28px;
              margin-bottom: 10px;
              margin-top:2px
            }
            span{
              display: inline-block;
              vertical-align: top;
              background: #fff;
              border-radius: 20px;
              margin-left: 6px;
              color: #4978a6;
              padding: 0 12px;
            }
          }
        }
      
      }
      .flex{
        display: flex;
        -webkit-box-pack: center;
        -webkit-box-align: center;
        .flex-s{
          flex:1;
          min-width: 0;
        }
      }
      .flex-colum{
        flex-flow: column;
      }
      .flex-middle{
        align-items: center;
      }
    }
  }
  .service {
    background: #f2f2f5;
    width:100%;
    margin-top: 30px;
    margin-bottom: 30px;
    .stitle {
      height: 50px;
      line-height: 60px;
      margin-bottom: 10px;
      margin-top:20px;
      font-size: 32px;
      padding-top: 10px;
      padding-bottom: 10px;
      text-align: center;
      span{
        font-weight: bold;
        color: #0e59f0;
      }
    }
    .serv_cate{
      overflow: hidden;
      padding-inline-start: 10px;
      padding-inline-end: 20px;
      padding-bottom: 20px;
      li{
        float: left;
        width: 50%;
        list-style: none;
        text-align: -webkit-match-parent;
        margin-bottom:15px;
        p{
          text-indent: 2em;
          line-height: 30px;
          font-size: 16px;
          padding-right: 8px;
        }
        .icon{
          position: absolute;
          right: 0;
          top: 50%;
          color: #b6b1c5;
          font-size: 24px;
          margin-top: -15px;
          margin-right: 10px;
          &:hover{
            color: #0e59f0;
          }
        }
        dl{
          overflow: hidden;
          padding: 0 15px;
          dd{
            float: left;
            width: 100%;
            margin-inline-start: 0px;
            span {
              color: #333333;
              line-height: 24px;
              display: inline-block;
              font-weight: bold; 
            }
            .circle{
              width: 10px;
              height: 10px;
              background-color: #0e59f0;
              border-radius:5px;  
              display: inline-block;
              margin-right: 7px;
            }
          }
        }
        div{
          margin-left: 12px;
          padding: 15px;
          border: 1px solid #dddddd;
          box-shadow: 0px 2px 10px 0px #ddd;
          background: #ffffff;
          border-radius: 10px;
          a{
            position: relative;
            display: block;
            width: 100%;
            span{
              position: absolute;
              bottom: 32px;
              margin-left: 25px;
              font-size: 20px;
              color: #333333;
              font-weight: bold; 
              &:hover{
                color: #0e59f0;
              }
            }
          }
        }
      }
    }
   }
  .tech {
    background: #f2f2f5;
    width:100%;
    margin-top: 30px;
    margin-bottom: 30px;
    .stitle {
      height: 50px;
      line-height: 60px;
      margin-bottom: 10px;
      font-size: 32px;
      padding-top: 10px;
      padding-bottom: 10px;
      text-align: center;
      span{
        font-weight: bold;
        color: #0e59f0;
      }
    }
    .serv_cate{
      overflow: hidden;
      padding-inline-start: 10px;
      padding-inline-end: 10px;
      li{
        float: left;
        width: 33%;
        list-style: none;
        text-align: -webkit-match-parent;
        margin-bottom:15px;
        .icon{
          position: absolute;
          right: 0;
          top: 50%;
          color: #b6b1c5;
          font-size: 24px;
          margin-top: -15px;
          &:hover{
            color: #0e59f0;
          }
        }
        dl{
          overflow: hidden;
          padding: 0 15px;
          dd{
            float: left;
            width: 50%;
            margin-inline-start: 0px;
            a {
              color: #333333;
              padding-top: 20px;
              display: inline-block;
              font-weight: bold; 
            }
          }
        }
        div{
          margin-left: 12px;
          padding: 15px;
          border: 1px solid #dddddd;
          box-shadow: 0px 2px 10px 0px #ddd;
          background: #ffffff;
          border-radius: 10px;
          a{
            position: relative;
            display: block;
            width: 100%;
            span{
              position: absolute;
              bottom: 32px;
              margin-left: 25px;
              font-size: 20px;
              color: #333333;
              font-weight: bold; 
              &:hover{
                color: #0e59f0;
              }
            }
          }
        }
      }
    }
  }
  a{
    color: #2d1779;
    text-decoration: none;
    transition: all 0.5s;
    -o-transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    cursor: pointer;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/index.vue